
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1152_657)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","transform":"rotate(-180 25 23)","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.262 31.736a.892.892 0 00.633.264H29.42a.892.892 0 00.633-.264.903.903 0 00.262-.636v-2.7h-1.79v1.8H17.79V15.8h10.736v1.8h1.79v-2.7a.903.903 0 00-.262-.636.892.892 0 00-.633-.264H16.895a.892.892 0 00-.633.264.903.903 0 00-.262.636v16.2c0 .239.094.468.262.636zM26.737 19.4v2.7H33v1.8h-6.263v2.7L22.263 23l4.474-3.6z","fill":"#28A920"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1152_657","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1152_657"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1152_657","result":"shape"}})])])])
          )
        }
      }
    